import get from 'lodash/get';
import * as micYearActions from '../../action_creators/mic/mic_year_action_creators';
import MicYearModel from '../../../models/mic/mic_year_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchMicDetail(params, store) {
  const handleLegacyMappings = companyArray => {
    if (!companyArray || companyArray.length <= 0) return [];

    const mappings = {
      ranking: 'ranking',
      why_here: 'why',
      media: 'media',
      media_orientation: 'media_orientation',
      caption: 'caption',
      credits: 'credits',
      related_article: 'related_article',
      summary: 'summary',
      read_more_text: 'read_more_text'
    };

    return companyArray.map(company =>
      Object.keys(company).reduce((acc, key) => {
        if (mappings[key]) {
          acc[mappings[key]] = company[key];
        } else {
          acc[key] = company[key];
        }
        return acc;
      }, {})
    );
  };

  return function firstDispatch(dispatch) {
    return MicYearModel.fetch(params, store)
      .then(function handleMicDetailData(MicData) {
        const { year } = params;
        if (year < 2020 && year > 2007) {
          dispatch(
            micYearActions.micYearLoaded(
              {
                rows: handleLegacyMappings(MicData.data)
              },
              store,
              params.year
            )
          );
        } else {
          dispatch(
            micYearActions.micYearLoaded(MicData.data, store, params.year)
          );
        }
      })
      .catch(function handleUserError(err) {
        if (err.message === 'Invalid Year') {
          log.warn('User tried a most creative people page with invalid year.');
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          return dispatch(micYearActions.micYearLoadError(err, store));
        }

        const status = get(err, 'response.status');

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in micYear actions, message: ${err.message}`);
        }

        return dispatch(micYearActions.micYearLoadError(err, store));
      });
  };
}
